import { ModalContent } from '@nile/banyan/src/Utils/style';
import styled from 'styled-components';

const Modal = styled(ModalContent)`
  .chartSection {
    background: var(--sops-lightpurple-to-black-bg);
    height: calc(100vh - 220px);
    .chartContainer {
      margin: 10px;
      border-radius: 5px;
      width: ${(props) =>
        props.isViewOnly || props.isFullScreen ? '0%' : '50%'};
      transition: all 0.2s ease;
      padding: ${(props) => (props.isFullScreen ? '0px' : '30px 20px')};
      background-color: var(--sops-white-to-grey-bg);
      overflow: auto;
      height: ${(props) =>
        props?.showBanner ? 'calc(100% - 100px)' : 'calc(100% - 20px)'};
      scrollbar-width: none;
      &::-webkit-scrollbar {
        display: none;
      }
      &:hover {
        ::-webkit-scrollbar {
          display: block;
        }
      }
    }
    .chartOptions {
      width: ${(props) => (props.isFullScreen ? '100%' : '50%')};
      transition: ${(props) =>
        props.isFullScreen ? 'none' : 'width 0.2s ease'};
      padding: 10px 20px;
      overflow: auto;
      height: 100%;
      .dataCard {
        display: ${(props) => (props.isTableExpanded ? 'none' : 'block')};
      }
      .dataTableCard {
        padding-bottom: 20px;
      }
    }
    .minimizer {
      position: relative;
      cursor: pointer;
      .minimizeBtn {
        top: 30px;
        left: ${(props) => (props.isFullScreen ? '0px' : '-30px;')};
        position: absolute;
        padding: 5px;
        border-radius: 50%;
        background: white;
        border: 2px solid #efefef;
      }
    }
  }
`;

export { Modal };
